var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.$auth.check('corp'))?_c('Nav'):_vm._e(),_c('v-main',{staticStyle:{"background-color":"#f0f2f5"}},[_c('router-view')],1),_c('Footer'),_c('OrderDetail'),_c('UserDetail'),_c('OrderListByUserId'),_c('ShowPhoto'),_c('EditService'),_c('ServiceView'),_c('StripeCharge')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }